if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        this.items = []
        this.redUpsell = this.dataset.redUpsell;

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const productInfo = document.querySelector("product-info");
        const selectedRedValue = productInfo ? productInfo.selectedRedValue : null;
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        // Prevent submission while color variant is being resolved (race condition guard)
        if (window._colorVariantResolving) return;

        // Prevent concurrent cart submissions
        if (this._isSubmitting) return;
        this._isSubmitting = true;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        // Delete Content-Type unless we're using JSON for red upsell
        if (!this.redUpsell || selectedRedValue !== "yes") {
          delete config.headers["Content-Type"];
        }

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const pdpButton = document.getElementById("openDrawerBtn");
        if (pdpButton) {
          const kitSize = pdpButton.getAttribute("data-kit-size");
          const doorType = pdpButton.getAttribute("data-door-type");
          const roofType = pdpButton.getAttribute("data-roof-type");
          const materialGrade = pdpButton.getAttribute("data-material-grade");
          const airRelease = pdpButton.getAttribute("data-air-release");

          // Append the attributes to formData
          kitSize && formData.append("properties[Kit Size]", kitSize);
          doorType && formData.append("properties[Door Type]", doorType);
          roofType && formData.append("properties[Roof Type]", roofType);
          materialGrade &&
            formData.append("properties[Material Grade]", materialGrade);
          airRelease && formData.append("properties[Air Release]", airRelease);
        }
        const ColourValue = this.getAttribute("data-colour-value");
        ColourValue && formData.append("properties[Colour]", `${ColourValue}`); // Add the extra object to formData

        config.body = formData;
        selectedRedValue === "no" && formData.append("properties[Reds]", "no");
        if (this.redUpsell && selectedRedValue === "yes") {
          let properties = {};
          for (const [key, value] of formData.entries()) {
            if (key.includes('properties[')) {
              const propKey = key.replace('properties[', '').replace(']', '');
              properties[propKey] = value;
            }
          }
          this.items = [
            {
              id: this.variantIdInput.value,
              quantity: formData.get("quantity") || 1,
              properties: properties
            },
            {
              id: JSON.parse(this.redUpsell).variants[0].id,
              quantity: formData.get("quantity") || 1,
              parent_id: this.variantIdInput.value
            }
          ]
          const requestBody = {
            items: this.items,
            sections: this.cart && this.cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
          };
          config.body = JSON.stringify(requestBody)
        } else {
          config.body = formData;
        }
        console.log("Form Data Items:", config.body);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            
            // GA4 Recommended Event: add_to_cart
            if (!this.error && window.GTMEvents) {
              window.GTMEvents.addToCart(
                (response.items || [response]).map(function(item) {
                  return {
                    id: item.product_id,
                    name: item.product_title,
                    variant: item.variant_title,
                    price: parseFloat(item.price) / 100,
                    quantity: item.quantity
                  };
                }),
                window.Shopify?.currency?.active || 'GBP'
              );
            }
            
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
          })
          .finally(() => {
            this._isSubmitting = false;
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
